"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _tablePage = _interopRequireDefault(require("_c/CommonForm/table-page"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'log-manage',
  components: {
    TablePage: _tablePage.default
  },
  data: function data() {
    return {
      dialogErrorShow: false,
      columns: [{
        label: '操作人员',
        prop: 'operName'
      }, {
        label: '请求地址',
        prop: 'url'
      }, {
        label: 'ip地址',
        prop: 'ip'
      }, {
        label: '业务模块名称',
        prop: 'businessName'
      }, {
        label: '请求参数',
        prop: 'operParam',
        showOverflowTooltip: true
      }, {
        label: '方法名',
        prop: 'method',
        showOverflowTooltip: true
      }, {
        label: '返回结果',
        prop: 'result',
        showOverflowTooltip: true
      }, {
        label: '错误信息',
        slot: 'error'
      }],
      queryParams: {},
      error: null
    };
  },
  methods: {
    change: function change(e) {
      this.$forceUpdate();
    },
    /**
     * 刷新
     */
    refresh: function refresh() {
      this.$refs.tablePage.refresh();
    },
    /**
     * 重置搜索条件
     */
    reset: function reset() {
      this.queryParams = {};
      this.$nextTick(function () {
        this.refresh();
      });
    },
    /**
     * 重置表单
     * @param name
     */
    handleReset: function handleReset(name) {
      this.$refs[name].resetFields();
    },
    showError: function showError(error) {
      this.dialogErrorShow = true;
      this.error = error;
    }
  },
  mounted: function mounted() {}
};